import { mean } from "d3-array";
import { slidingWindow } from "../utils";
import { MedianPrice as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { windowSize } = options;

    // First, calculate median price for each bar: (high + low) / 2
    const medianPrices = data.map((d) => {
      if (!d || d.high === undefined || d.low === undefined) return undefined;
      return (d.high + d.low) / 2;
    });

    // Then apply SMA to the median prices
    const average = slidingWindow()
      .windowSize(windowSize)
      .accumulator((values) => mean(values));

    return average(medianPrices);
  }

  calculator.undefinedLength = function () {
    return options.windowSize - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
